import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./features/userSlice";
import adminReducer, { clearAuth } from "./features/adminSlice";
import campaignsReducer from "./features/campaignsSlice";
import sellerReducer from "../store/slices/sellerSlice";
import cashierReducer from "../store/slices/cashierSlice";
import sellerCustomerTiersReducer from "../store/slices/sellerCustomerTiersSlice";
import earningScheduleReducer from "../store/slices/earningScheduleSlice";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import { combineReducers } from "@reduxjs/toolkit";
import tokenMiddleware from "./middlewares/tokenMiddleware";
import { setStoreReference } from "./api";

const persistConfig = {
  key: "root",
  // ROOT-CAUSE FIX (2026-09-02) for the cyclic auth-guard reload loop after
  // hot reloads: authentication/session slices are BLACKLISTED from
  // persistence. On every page load the user/session is rebuilt from the
  // server session cookie (/auth/status + /auth/me) — the cookie/Redis is the
  // single source of truth. A stale persisted user can therefore NEVER be
  // rehydrated into a new bundle after HMR, which is what caused the loop.
  // Only UI/feature state (campaigns, tiers, earning schedule) is persisted.
  version: 2,
  storage,
  blacklist: ['user', 'admin', 'seller', 'cashier'],
  migrate: (state) => {
    if (state && state._persist && state._persist.version !== 2) {
      return Promise.resolve(undefined);
    }
    return Promise.resolve(state);
  },
};

const loyalty = combineReducers({
  user: userReducer,
  admin: adminReducer,
  campaigns: campaignsReducer,
  seller: sellerReducer,
  cashier: cashierReducer,
  sellerCustomerTiers: sellerCustomerTiersReducer,
  earningSchedule: earningScheduleReducer,
});

const persistedReducer = persistReducer(persistConfig, loyalty);

export const store = configureStore({
  reducer: {
    loyalty: persistedReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(tokenMiddleware),
});

// Set store reference in API module for 401 handling
setStoreReference(store, clearAuth);
